export default {
	props: {
		value: {
			required: true
		},
		id: {
			required: false,
			default: 'call-request-phone-number-input'
		},
		ariaControls: {
			required: false
		},
		ariaDescribedby: {
			required: false,
			type: String
		},
		ariaLabelledby: {
			required: false,
			type: String
		}
	},
	data() {
		return {};
	},
	watch: {
		value(val) {
			if (val && val.length == this.$el.maxLength) {
				this.$emit('on-jump');
			}
		}
	},
	methods: {
		/**
		 * Formátum validálás billentyű leütés után
		 * @param {*} e
		 */
		validate(e) {
			// csak szamokat engedjen
			if (e.which && !e.ctrlKey && !e.metaKey && e.which != 8 && e.which != 46 && e.which != 37 && e.which != 39 && isNaN(String.fromCharCode(e.which))) {
				e.preventDefault();
			}
		},
		onPaste(e) {
			e.preventDefault();
			// nem szamok kiszurese
			let clipboardData = e.clipboardData || window.clipboardData;
			let pasted = clipboardData.getData('Text').replace(/\D/g, '');
			// 06 / 36 / +36 lecsereles
			if (pasted.indexOf('06') == 0 || pasted.indexOf('36') == 0) {
				pasted = pasted.substring(2);
			}
			// maxlength levagas
			pasted = pasted.substring(0, 11);
			e.target.value = this.formatNumber(pasted);
		},
		onInput(e) {
			this.$emit('input', this.formatNumber(e.target.value));
		},
		formatNumber(number) {
			let formattedNumber = '';
			number = number.replace(/ /img, '');
			if (number.length < 2) {
				formattedNumber = number;
			} else if (number.length >= 5) {
				formattedNumber = number.substring(0, 2) + ' ' + number.substring(2, 5) + ' ' + number.substring(5);

			} else if (number.length >= 2) {
				formattedNumber = number.substring(0, 2) + ' ' + number.substring(2, 5);
			}
			setTimeout(() => {
				if (this.$refs['phonenumber-input'] && this.$refs['phonenumber-input'].offsetParent &&
					this.$refs['phonenumber-input'] == document.activeElement){ // csak akkor mókoljon, ha látható
					this.$refs['phonenumber-input'].selectionStart = this.$refs['phonenumber-input'].selectionEnd = 10000;
				}
			}, 0);
			return formattedNumber.trim();
		}
	}
};
